import React from "react";
import { motion } from "framer-motion";
import { Send, CheckCircle2, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

const SM_ACCENT = "#8B5CF6";

export const SMLeadForm = ({ percorsi = [], defaultTopic = "", compact = false }) => {
  const [form, setForm] = React.useState({ name: "", email: "", phone: "", company: "", participants: "", topic: defaultTopic, message: "" });
  const [busy, setBusy] = React.useState(false);
  const [done, setDone] = React.useState(false);
  const [err, setErr] = React.useState("");
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  React.useEffect(() => { setForm((f) => ({ ...f, topic: defaultTopic })); }, [defaultTopic]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/sm/leads", form);
      setDone(true);
    } catch (ex) {
      setErr(formatApiErrorDetail(ex.response?.data?.detail));
    } finally { setBusy(false); }
  };

  if (done) return (
    <motion.div initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }} data-testid="sm-lead-success"
      className="rounded-3xl border border-[#8B5CF6]/20 bg-[#8B5CF6]/5 p-8 text-center">
      <CheckCircle2 size={40} className="mx-auto mb-3" style={{ color: SM_ACCENT }} />
      <h3 className="font-display font-800 text-xl" style={{ color: "#4c1d95" }}>Richiesta inviata!</h3>
      <p className="text-gray-500 mt-2 text-sm">Grazie {form.name.split(" ")[0]}, ti ricontatteremo al più presto per costruire insieme il percorso più adatto.</p>
    </motion.div>
  );

  const input = "w-full px-4 py-3 rounded-xl border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#8B5CF6]/25 focus:border-[#8B5CF6] transition-all";

  return (
    <form onSubmit={submit} data-testid="sm-lead-form" className="space-y-3">
      <div className={`grid gap-3 ${compact ? "grid-cols-1" : "sm:grid-cols-2"}`}>
        <input data-testid="lead-name" required placeholder="Nome e cognome *" value={form.name} onChange={set("name")} className={input} />
        <input data-testid="lead-email" required type="email" placeholder="Email *" value={form.email} onChange={set("email")} className={input} />
        <input data-testid="lead-phone" placeholder="Telefono" value={form.phone} onChange={set("phone")} className={input} />
        <input data-testid="lead-company" placeholder="Azienda" value={form.company} onChange={set("company")} className={input} />
        <input data-testid="lead-participants" placeholder="N° partecipanti" value={form.participants} onChange={set("participants")} className={input} />
        <select data-testid="lead-topic" value={form.topic} onChange={set("topic")} className={`${input} bg-white`}>
          <option value="">Percorso di interesse…</option>
          {percorsi.map((p) => <option key={p.slug || p.id} value={p.title}>{p.title}</option>)}
          <option value="Percorso su misura">Percorso su misura</option>
        </select>
      </div>
      <textarea data-testid="lead-message" rows={3} placeholder="Raccontaci obiettivi ed esigenze…" value={form.message} onChange={set("message")} className={input} />
      {err && <p className="text-sm text-[#EF4444] bg-red-50 rounded-lg px-3 py-2">{err}</p>}
      <button data-testid="lead-submit" type="submit" disabled={busy}
        className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full text-white font-600 hover:scale-[1.02] disabled:opacity-60 transition-transform"
        style={{ background: `linear-gradient(135deg,#4c1d95 0%,${SM_ACCENT} 100%)` }}>
        {busy ? <Loader2 size={17} className="animate-spin" /> : <Send size={17} />} Invia richiesta
      </button>
    </form>
  );
};
